document.addEventListener('DOMContentLoaded', function () {

    const DOMESTIC_CODES = ['US', 'GU', 'MP', 'WS', 'VI', 'PR'];
    const GEO_TIMEOUT_MS = 5000;

    // ------------------------------------------------------------------
    // Geo: runs once on page load to show the correct button set
    // ------------------------------------------------------------------

    async function initButtonDisplay() {
        const atcDomestic = document.getElementById('smartButtons');
        const atcInt = document.getElementById('smartButtonsInt');

        let isDomestic = false;

        try {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), GEO_TIMEOUT_MS);

            const response = await fetch(
                'https://ipgeolocation.abstractapi.com/v1/?api_key=51e316b48a0140f896e4da1589259c44',
                { signal: controller.signal }
            );

            clearTimeout(timeout);

            if (response.status === 429) {
                console.error('Geo API rate limited (429) - defaulting to international');
            } else if (!response.ok) {
                console.error('Geo API error:', response.status, '- defaulting to international');
            } else {
                const data = await response.json();
                isDomestic = DOMESTIC_CODES.includes(data.country_code);
            }
        } catch (e) {
            if (e.name === 'AbortError') {
                console.error('Geo API timed out - defaulting to international');
            } else {
                console.error('Geo API fetch failed - defaulting to international:', e);
            }
        }

        if (isDomestic) {
            if (atcDomestic) atcDomestic.style.display = 'flex';
            if (atcInt) atcInt.style.display = 'none';
        } else {
            if (atcInt) atcInt.style.display = 'flex';
            if (atcDomestic) atcDomestic.style.display = 'none';
        }
    }

    // ------------------------------------------------------------------
    // Cart/variant helpers
    // ------------------------------------------------------------------

    async function getCurrentProductVariants(url) {
        const productRes = await fetch((url || window.location.pathname) + '.js');

        if (!productRes.ok) {
            return null;
        }

        const productData = await productRes.json();
        return productData.variants;
    }

    async function getCurrentCartVariants() {
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        return cartData.items;
    }

    // ------------------------------------------------------------------
    // Compare: updates button text/state based on cart contents
    // Reads whichever button is currently visible - no geo involved
    // ------------------------------------------------------------------

    function getActiveButton() {
        const atcDomestic = document.getElementById('smartButtons');
        const atcInt = document.getElementById('smartButtonsInt');

        if (atcDomestic && atcDomestic.style.display === 'flex') return null;
        if (atcInt && atcInt.style.display === 'flex') return atcInt;
        return null;
    }

    async function compare(productUrl) {
        const button = getActiveButton();

        if (!button) return;

        const productVariantsArr = await getCurrentProductVariants(productUrl);

        if (!productVariantsArr) return;

        const cartVariantsArr = await getCurrentCartVariants();

        const anyVariantAvailable = productVariantsArr.some(variant => variant.available);

        if (!anyVariantAvailable) {
            button.setAttribute('disabled', 'disabled');
            button.innerHTML = 'Sold Out';
            return;
        }

        if (!cartVariantsArr || cartVariantsArr.length === 0) {
            button.removeAttribute('disabled');
            button.innerHTML = 'Add to Cart';
            return;
        }

        let cartVariantMap = new Map(cartVariantsArr.map(cartVariant => [cartVariant.variant_id, cartVariant]));

        productVariantsArr.forEach((productVariant) => {
            let cartVariant = cartVariantMap.get(productVariant.id);
            if (cartVariant) {
                if (cartVariant.quantity === 2) {
                    button.setAttribute('disabled', 'disabled');
                    button.innerHTML = 'Max Qty Reached (2/2)';
                } else if (cartVariant.quantity === 1) {
                    button.removeAttribute('disabled');
                    button.innerHTML = 'Add to Cart (1/2)';
                } else {
                    button.removeAttribute('disabled');
                    button.innerHTML = 'Add to Cart';
                }
            }
        });
    }

    // ------------------------------------------------------------------
    // Event listeners: cart events only update text, no geo calls
    // ------------------------------------------------------------------

    document.addEventListener('quickview:loaded', function (e) {
        e.stopPropagation();
        const productUrl = e.detail !== null ? e.detail.productUrl : null;
        compare(productUrl);
    });

    document.addEventListener('cart:updated', function (e) {
        const productUrl = e.detail !== null ? e.detail.productUrl : null;
        compare(productUrl);
    });

    document.addEventListener('cart:added', function (e) {
        const productUrl = e.detail !== null ? e.detail.productUrl : null;
        setTimeout(() =>compare(productUrl), 800);
    });

    document.addEventListener('ajaxProduct:added', function (e) {
        const productUrl = e.detail !== null ? e.detail.productUrl : null;
        compare(productUrl);
    });

    // ------------------------------------------------------------------
    // Init: geo runs once, then compare sets initial button text
    // ------------------------------------------------------------------

    if (window.location.pathname.includes('/products/')) {
        initButtonDisplay().then(() => compare(null));
    }

});